import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { getImageUrl } from "src/Common/common";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

const MENU_WIDTH = 28;
// Rough per-item height (14px icon + my-1 margins) plus container py-1 —
// only used to decide whether to flip the menu upward near the viewport edge.
const ITEM_HEIGHT = 22;

// canEdit / canDelete default to true so existing callers are unaffected;
// permission-gated callers (e.g. Vendor) pass them explicitly.
// The menu is rendered through a portal at a fixed viewport position so it
// can't be clipped by overflow-hidden/auto table containers (bottom rows),
// and flips upward when there is no room below the trigger.
function DropDown({ index, onDeleteClicked, onEditClicked, canEdit = true, canDelete = true }) {
  const [optionShown, setOptionShown] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  // Nothing actionable — don't render the menu trigger at all.
  if (!canEdit && !canDelete) return null;

  const toggle = () => {
    if (!optionShown && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const menuHeight = 8 + (canEdit ? ITEM_HEIGHT : 0) + (canDelete ? ITEM_HEIGHT : 0);
      const openUp = rect.bottom + 4 + menuHeight > window.innerHeight;
      setMenuPos({
        top: openUp ? rect.top - menuHeight - 4 : rect.bottom + 4,
        left: rect.left + rect.width / 2 - MENU_WIDTH / 2,
      });
    }
    setOptionShown(!optionShown);
  };

  return (
    <div className="relative">
      <img ref={triggerRef} onClick={toggle} className="cursor-pointer" src={getImageUrl("/images/common/options.png")} />
      {optionShown &&
        createPortal(
          <OutsideClickHandler
            onOutsideClick={() => {
              setOptionShown(false);
            }}
          >
            <div
              style={{ top: menuPos.top, left: menuPos.left, width: MENU_WIDTH }}
              className="fixed flex flex-col items-center py-1 justify-between border-[1px] rounded-[6px] border-borderColor bg-white z-50 shadow-md"
            >
              {canEdit && (
                <img
                  onClick={() => {
                    onEditClicked(index);
                    setOptionShown(false);
                  }}
                  className="w-[14px] my-1 cursor-pointer"
                  src={getImageUrl("/images/common/edit.png")}
                />
              )}
              {canDelete && (
                <img
                  onClick={() => {
                    onDeleteClicked(index);
                    setOptionShown(false);
                  }}
                  className="w-[14px] my-1 cursor-pointer"
                  src={getImageUrl("/images/common/black_trash.png")}
                />
              )}
            </div>
          </OutsideClickHandler>,
          document.body,
        )}
    </div>
  );
}

export default DropDown;
